import * as THREE from "three";
import { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { MeshReflectorMaterial } from "@react-three/drei";
import {
  Vignette,
  EffectComposer,
  Noise,
  Bloom,
} from "@react-three/postprocessing";
import Frames from "./Frames";
import CustomBackground from "./CustomBackground";
import CustomTexts from "./CustomTexts";

const About = () => {
  return (
    <Canvas dpr={[1, 1.5]} camera={{ fov: 70, position: [0, 2, 15] }}>
      <color attach="background" args={["#469908"]} />
      <Scene />
    </Canvas>
  );
};

const Scene = () => {
  const concepts = {
    frame1: {
      title: "PEPE THE ADVENTUROUS FROG COIN",
      text: "Emerging from the depths of the digital realm, Pepe the Frog Coin was brought to life with a mission to explore the vast expanse of the crypto universe. With his innate ability to leap between blockchain networks, Pepe embarks on thrilling journeys across Binance Smart Chain and Polygon, bridging communities and spreading joy. Through his adventures, Pepe transforms the meme culture into a symbol of innovation and inclusivity, ushering in a new era of decentralized creativity. Join Pepe on his quest to unlock the power of blockchain connectivity and revolutionize the way we perceive digital assets. Ribbit!",
    },
    frame2: {
      title: "THE MULTICHAIN MEME TOKEN",
      text: "Introducing Pepe Coin, the revolutionary meme token that is taking the crypto world by storm. As the first Pepe-themed cryptocurrency built on a multichain network including Ethereum, BNB Chain and Polygon. Pepe Coin invites you to join a vibrant community of Pepe enthusiasts where creativity, rewards, and camaraderie come together in perfect harmony. Step into the world of Pepe Coin and experience the interconnected universe of meme magic like never before",
    },
    frame3: {
      title: "LAUNCH IN 3 STELLAR CHAINS",
      text: "Pepe Coin strives to unite the crypto meme community and position itself as the vanguard of multichain utility. As the first Pepe meme to be released on three different blockchains, Pepe's only wish is to see his name shine on every DEX, every CEX, and every place where meme degens congregate. With a nose for interstellar convergence, Pepe brings a multichain dimension to what it means to be trending on DEXTools.",
    },
    frame4: {
      title: "PEPE'S GALACTIC EXPEDITION",
      text: "Pepe the Frog Coin is not just another meme token; it is an odyssey through the cosmos of cryptocurrency. Pepe's galactic expedition takes him through the intricacies of blockchain technology, exploring the unknown and pushing the boundaries of digital finance. By bridging multiple chains and fostering a culture of innovation, Pepe empowers a global community of crypto enthusiasts to boldly go where no frog has gone before. Join Pepe on this interstellar journey and be a part of the decentralized revolution.",
    },
  };
  const images = [
    {
      position: [-2.15, 0, 1.5],
      rotation: [0, Math.PI / 2.5, 0],
      url: "/assets/images/pepe1.jpg",
      item: concepts.frame1,
    },
    {
      position: [-1.5, 0, 0.25],
      rotation: [0, Math.PI / 6, 0],
      url: "/assets/images/pepe2.jpg",
      item: concepts.frame2,
    },
    // Right
    {
      position: [1.5, 0, 0.25],
      rotation: [0, -Math.PI / 6, 0],
      url: "/assets/images/pepe3.jpg",
      item: concepts.frame3,
    },
    {
      position: [2.15, 0, 1.5],
      rotation: [0, -Math.PI / 2.5, 0],
      url: "/assets/images/pepe4.jpg",
      item: concepts.frame4,
    },
  ];
  return (
    <group>
      <group position={[0, -0.5, 0]}>
        <Frames
          images={images}
          q={new THREE.Quaternion()}
          p={new THREE.Vector3()}
        />
        <Suspense fallback={null}>
          <CustomBackground />
        </Suspense>
        <mesh position={[0, -0.1, 0]} rotation={[-Math.PI / 2, 0, 0]}>
          <circleGeometry args={[8, 20]} />
          <MeshReflectorMaterial
            blur={[300, 100]}
            resolution={2048}
            mixBlur={1}
            mixStrength={10}
            roughness={0.99}
            depthScale={1.1}
            minDepthThreshold={0.4}
            maxDepthThreshold={1.3}
            color="#469908"
            metalness={0.8}
            mirror={1}
          />
        </mesh>
      </group>

      <EffectComposer>
        <Vignette offset={0.5} darkness={0.7} />
        <Noise premultiply />
        <Bloom mipmapBlur intensity={0.6} luminanceThreshold={0.9} />
      </EffectComposer>
      <ambientLight intensity={10}/>

      <CustomTexts />
    </group>
  );
};

export default About;
